import { useEffect } from 'react';

// Renders nothing and immediately signals completion - used to suppress all effects
const NoopEffect = ({ onComplete }) => {
  useEffect(() => { onComplete?.(); }, [onComplete]);
  return null;
};

const DefaultTheme = {
  name: 'Default',
  getBlockColor: require('./DefaultMaterial').getBlockColor,
  getEmissiveColor: require('./DefaultMaterial').getEmissiveColor,
  COLORS: require('./DefaultMaterial').DEFAULT_COLORS,
  TETROMINO_COLORS: require('./DefaultMaterial').DEFAULT_TETROMINO_COLORS,
  config: require('./DefaultMaterial').THEME_CONFIG,
  BoardGrid3D: require('./DefaultBoardGrid3D').default,
  Block3D: require('./DefaultBlock3D').default,
  InstancedBoard: require('./DefaultInstancedBoard').default,
  effects: {
    LineClearEffect: NoopEffect,
    TetrisFinisher: NoopEffect,
    HardDropTrail: NoopEffect,
    BlockPlaceEffect: NoopEffect,
  },
};

export default DefaultTheme;
